<template>
  <div class="shop-popular-slider">
    <div class="container">
      <div class="slider-heading">{{ $t('Популярные магазины') }}</div>
      <carousel :perPage="1" :perPageCustom="[[600, 2], [768, 3], [1024, 5]]" paginationActiveColor="#3c91e6" paginationColor="#f0f1f4" :paginationPadding="3" v-if="popularShops.length">
        <slide class="slider-item-wrapper" v-for="shop in popularShopsSlides" :key="shop.id">
          <a :href="shopUrl(shop.slug)" class="slider-item">
            <div class="slider-image">
              <app-img class="slider-logo" :src="shop.image || shop.logo_url" :alt="shop.name"></app-img>
            </div>
            <div class="slider-description">
              <p>{{ $t('Кэшбэк') }}</p>
              <p class="percent">{{ shop.cashbe_value }}<span v-if="shop.cashbe_type === 'fixed'">руб.</span><span v-else>%</span></p>
            </div>
          </a>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppImg from '../AppImg.vue';

export default {
  name: 'shop-popular',

  components: {
    AppImg
  },

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapState(['popularShops']),

    popularShopsSlides() {
      return this.popularShops.slice(0, 15);
    }
  },

  methods: {}
}
</script>

<style scoped>
.shop-popular-slider {
  margin: 20px 0 0 0;
  padding: 50px 0 30px 0;
  background-color: #dbdce1;
}

.slider-heading {
  margin: 0 0 20px 0;
  font-size: 36px;
  font-weight: bold;
}

.slider-item-wrapper {
  padding: 15px 10px;
}

.slider-item {
  display: block;
  height: 285px;
  border-radius: 3px;
  box-shadow: 0px 5px 10px 0px rgba(6, 19, 50, 0.15);
  transition: transform .5s ease, box-shadow .5s ease;
}

.slider-item:hover {
  transform: translateY(-10px);
  box-shadow: 0px 15px 15px 0px rgba(6, 19, 50, 0.15);
}

.slider-item:hover .slider-description {
  background-color: #3c91e6;
}

.slider-item:active .slider-description {
  background-color: #29629c;
}

.slider-image {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 200px;
  background-color: #fff;
}

.slider-description {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 85px;
  background-color: #ffca27;
}

.slider-description p {
  margin: 0;
  color: #000000;
  font-size: 18px;
  font-weight: normal;
}

.slider-description .percent {
  font-size: 36px;
  font-weight: bold;
}

@media (max-width: 1023px) {
 .slider-item-wrapper {
    padding: 15px 20px;
  }
}

@media (max-width: 767px) {
  .shop-popular-slider {
    padding: 30px 0;
  }

  .slider-heading {
    font-size: 22px;
  }
}
</style>